import PropTypes from 'prop-types';

import { ClassNameDefaultProps } from '@/common/proptypes/Base/ClassName.protypes';
import {
  DisabledDefaultProps,
  DisabledPropTypes,
} from '@/common/proptypes/Base/Disabled.proptypes';

export const OptionDefaultProps = {
  ...ClassNameDefaultProps,
  ...DisabledDefaultProps,
  active: false,
  count: null,
  name: null,
  onChange: () => {},
  title: null,
  value: null,
};

export const OptionPropTypes = {
  ...DisabledDefaultProps,
  ...DisabledPropTypes,
  active: PropTypes.bool,
  count: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string,
  value: PropTypes.number,
};
